import { IoMenu } from 'react-icons/io5';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import NotificationBell from './NotificationBell';
import './Header.css';

const Header = ({ onMenuClick, menuOpen }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  // Check if we're on the auth page
  const isOnAuthPage = location.pathname === '/auth';

  return (
    <>
      {/* Mobile Church Display */}
      {isAuthenticated && user?.church && (
        <div className="mobile-church-display">
          <span className="mobile-church-name">{user.church.name}</span>
        </div>
      )}
      <header className="header">
        <div className="header-content">
        <div className="header-left">
          {isAuthenticated && (
            <button 
              className="menu-button"
              onClick={onMenuClick}
              aria-label="Open menu"
              aria-expanded={menuOpen}
              aria-controls="app-navigation"
            >
              <IoMenu size={24} />
            </button>
          )}
          <Link to="/" className="title-link">
            <div className="title-container">
              <img src="/logo.jpeg" alt="ReadTheWord Logo" className="app-logo" />
              <span className="app-title">ReadTheWord</span>
            </div>
          </Link>
          {isAuthenticated && user?.church && (
            <div className="church-display">
              <span className="church-name">{user.church.name}</span>
            </div>
          )}
        </div>
        
        <div className="header-right">
          {isAuthenticated ? (
            <>
              {/* User Profile Section */}
              <div className="user-profile-section">
                <Link to="/settings#account" className="user-profile-link" aria-label="Account settings">
                  <div className="profile-picture-container">
                    <div className="profile-picture">
                      <span className="profile-initial">
                        {user?.name?.charAt(0)?.toUpperCase() || 'U'}
                      </span>
                    </div>
                  </div>
                  <span className="user-name">
                    {user?.name || 'User'}
                  </span>
                </Link>
              </div>

              {/* Notification Bell */}
              <NotificationBell />
            </>
          ) : !isOnAuthPage ? (
            <div className="auth-buttons">
              <Link to="/auth" className="login-button">
                Sign in
              </Link>
              <Link to="/auth?view=register" className="signup-button">
                Sign up
              </Link>
            </div>
          ) : null}
        </div>
      </div>
      </header>
    </>
  );
};

export default Header;
